<template>
  <div class="all-news relative max-w-[1180px] mx-auto mb-[48px] px-[20px] pt-20">
    <BreadCrumb />

    <div
      class="w-full max-w-[1180px] flex items-center justify-center sticky top-[88px] z-[400] bg-[#ffffffd1] backdrop-blur-[3px] transition" />
    <div class="head mt-8 flex flex-col w-full border-b-[1px] border-faintGrey dark:border-[#f6f6f671] py-8 mb-4">
      <h3 class="font-[600] text-[28px] leading-[39.99px] font-Playfair mb-4">
        News
      </h3>
      <p class="font-Rubik text-[17px] leading-[28px] font-[300] text-[#3D3D3D] dark:text-[#c8c8c8]">
        Insights on the latest news. Dig in!
      </p>
    </div>
    <template v-if="!newsStore.loading || stateNews.length > 0">
      <div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[11px]">
        <NuxtLink v-for="(post, index) in sortPostsByPublishDate(stateNews)" :key="index"
          :to="'/news/' + post.slug"
          class="post-thumb w-auto min-h-[330px] rounded-[4px] p-2 hover:bg-[#f6f6f6] dark:hover:bg-[#0f0f0fda] hover:scale-[1.005] transition-all cursor-pointer">
          <div class="thumbImg h-[330px] w-full mb-3 overflow-hidden rounded-[4px] flex items-start justify-start">
            <img v-if="post.coverImage !== undefined"
              :src="`${post.coverImage.url}`"
              :alt="post.coverImage.name" class="w-full h-full object-cover">
            <div v-else class="w-full h-full bg-faintGrey" />
          </div>
          <div class="flex items-center mb-[6px]">
            <span class="font-Rubik sm:text-[14px] text-[12px] sm:leading-[20px] leading-[16px] text-greyText">
              NEWS
            </span>
            <svg class="mx-[6px]" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="2" r="2" fill="#A3A3A3" />
            </svg>
            <span class="font-Rubik sm:text-[14px] text-[10px] sm:leading-[20px] leading-[16px] text-greyText">{{
              getDate(post.publishedAt) }}</span>
          </div>
          <h4 class="font-Rubik font-[500] sm:text-[17px] text-[16px] sm:leading-[28px] leading-[20px]"
            v-html="post.title" />
        </NuxtLink>
      </div>
    </template>
    <template v-else>
      <div
        class="head mt-8 flex items-center justify-between w-full border-b-[1px] border-faintGrey dark:border-[#f6f6f671] py-3 mb-4">
        <div class="font-Rubik block h-14 w-[25%] bg-faintGrey animate-pulse rounded-[3px] mb-4" />
        <div>
          <div class="font-Rubik block h-5 w-[70px] bg-faintGrey animate-pulse rounded-[3px]" />
        </div>
      </div>
      <CategoryPageSkeleton />
    </template>
    <NuxtPage />
  </div>
</template>

<script lang="ts" setup>
useHead(() => ({
  title: 'Chronicles - News',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Latest news articles on the Kinfolk blog. Don’t be a stranger, dig in!',
    },
    { hid: 'og:title', property: 'og:title', content: 'Founder Profiles' },
    {
      hid: 'og:description',
      property: 'og:description',
      content:
        'Latest news articles on the Kinfolk blog. Don’t be a stranger, dig in!',
    },
    { hid: 'og:image', property: 'og:image', content: '' },
    // Add more dynamic meta tags as needed
  ],
}))
const newsStore = useNewsStore()
const stateNews = ref<Post[]>([])

onBeforeMount(async () => {
  if (newsStore.data.length < 1) {
    stateNews.value = await newsStore.fetch()
  }
  stateNews.value = newsStore.data
})
</script>

<style></style>